<template>
  <v-container class="pa-0">
    <v-divider></v-divider>
    <h1 style="font-size:18px;color:#430F4A" class="py-4 px-0">Capa do lote</h1>
    <table v-if="!showUpload" width="100%">
      <thead style="background-color:#EFF3F8">
        <tr>
          <th class="pa-3 text-left" style="">Documento</th>
          <th class="pa-3 text-left" style="">Data</th>
          <th class="pa-3 text-center" style="">Baixar</th>
          <th v-if="!parameter || status!='F'" class="pa-3 text-center" style="">Excluir</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="pa-3 text-left">{{items.anexo}}</td>
          <td class="pa-3 text-left">{{items.capa_lote_dt_upload | formatDate}}</td>
          <td class="pa-3 text-center">
            <v-btn small color="primary lighten-2" icon @click="getDocument({doc_id: items.capa_lote_doc_id, nome: items.anexo})">
              <v-icon small>fa-download</v-icon>
            </v-btn>
          </td>
          <td v-if="!parameter || status!='F'" class="pa-3 text-center">
            <v-btn small :color="userData.PermissaoAcoes.faturamento.includes('deletecapalote') && !parameter? 'primary lighten-2': 'grey lighten-2'" icon>
              <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('deletecapalote') && !parameter" @click="deleteCapaLoteConfirm(items)" small>mdi-delete</v-icon>
              <v-icon v-else @click="userInfo()" small>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-if="!showUpload && items.capa_lote_doc_id==null && parameter">Não existe capa de lote disponível, contacte o administrador do sistema</p>
    <v-col v-show="showUpload" class="pt-0 pb-1" cols="12">
      <div v-if="parameter && status=='F'">
        <p class="text-center">Cronograma concluido</p>
      </div>
      <div v-else>
        <vue-dropzone
          v-if="userData.PermissaoAcoes.faturamento.includes('addcapalote')"
          ref="fileDropzone"
          class="pa-0"
          id="dropzone"
          :options="dropzoneOptions"
          @vdropzone-sending="sendFile"
          @vdropzone-error="rejectedFile"
          @vdropzone-complete="completeMessage"
        ></vue-dropzone>
        <p class="text-center" style="font-size:14px" v-else>Você não possui permissão para executar esta ação, contacte o administrador do sistema.</p>
        <!-- @vdropzone-file-added="addedFile" -->
        <!-- success -->
      </div>
    </v-col>
  </v-container>
</template>

<script>
import { mapActions } from "vuex"
var TOKEN = 'Bearer '.concat(sessionStorage.getItem('token'))
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
import moment from "moment";
moment.locale("pt-BR");
export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      showTable: false,
      qtdFiles: 0,
      headers: [
        { text: "Documento", align: "start", value: "anexo", sortable: false },
        { text: "Data", value: "capa_lote_dt_upload", sortable: false },
        { text: "Baixar", value: "baixar", sortable: false },
        { text: "Excluir", value: "excluir", sortable: false },
      ],
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL+"/api/proxy/upload",
        headers:{
          Authorization: TOKEN
        },
        paramName: "File",
        // acceptedFiles: '.pdf',
        maxFilesize: 12,
        maxFiles: 1,
        multiple: false,
        uploadMultiple: false,
        autoProcessQueue: true,
        dictDefaultMessage:
        `<v-spacer />
        <v-col cols='6'>
        <div class='mdi mdi-file-outline primary--text' style='font-size: 35px; color: #18a0fb; display: inline-block'></div>
        <div style='font-size: 12px; display: inline-block'>
            Arraste o arquivo ou <span class="primary--text">selecione</span><br>Faça upload de arquivos apenas no formato PDF.
            <br>Limite de 12MB por arquivo.</p>
        <v-spacer />
        </v-col>`,
        dictFallbackMessage: "Este browser não suporta a tecnologia utilizada para upload.",
        dictFallbackText: "Não entendi.",
        dictFileTooBig: "Não pode exceder: {{maxFilesize}}MB seu arquivo contém: {{filesize}}MB.",
        dictInvalidFileType: "Tipo de arquivo não aceito.",
        dictResponseError: "Ocorreu erro {{statusCode}}",
        dictRemoveFile: "Clique para remover o arquivo",
        dictMaxFilesExceeded: "Você só pode fazer o upload de uma capa por lote."
      },
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  computed: {
    dt_alteracao() {
      return this.items?.capa_lote_dt_alteracao || null
    }
  },
  watch:{
    showUpload(){
      this.$refs.fileDropzone.removeAllFiles()
    },
  },
  methods: {
    ...mapActions({
      getDocument: "documents/getDocument"
    }),
    rejectedFile(file){
       if(!File.accepted){
            var node = document.createElement("a")
            node.setAttribute('class','error-message')
            node.setAttribute('href','#')
            var textnode = document.createTextNode("remover arquivo")
            node.appendChild(textnode)
            node.addEventListener("click", e => {
              e.preventDefault()
              this.$refs.fileDropzone.removeFile(file)
            });
            file.previewElement.appendChild(node)
      }
    },
    sendFile(file, xhr, formData){
      let grupo_economico = this.$store.state.permissions.grupoEconomico
          let payload = JSON.stringify({ grupo_economico, lote_id: this.items.id, dt_alteracao: this.dt_alteracao })

          formData.append('Modulo', 'Faturamento');
          formData.append('Acao', 'addcapalote');
          formData.append('Payload', payload);
    },
    completeMessage(file){
      let payload = JSON.parse(JSON.parse( file.xhr.response))[0].Payload
    let comerro = !payload || !payload.sucesso
    
    let paramModal = {
            type: comerro.length? "error" : "success",
            title:  comerro.length? "Atenção!" : "Sucesso",
            message: comerro.length? 'Verifique os arquivos que não foram enviados' : payload.mensagem,
            callback:  ()=> this.getLotes(),
            btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
    },
    removeUploadedFiles(files, rejected){
      if(!rejected) {
        this.$refs.fileDropzone.removeAllFiles()
      } else {
        files.forEach(toDel => this.$refs.fileDropzone.removeFile(toDel))
      }
      this.getList(this.formData)
    },
    deleteCapaLoteConfirm(selectedItem) {
      let paramModal = {
        type: "error",
        title: "Exluir capa de lote?",
        message: 'Ao excluir este arquivo, esta capa não estará mais disponível. Mas você poderá subir outro arquivo.',
        callback: () => this.deleteCapaLote(selectedItem),
        btConfirm: { name: "Excluir", show: true, color: "error" },
        btCancel: { name: "Não", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },

    deleteCapaLote(selectedItem) {
      let obj = {
        query: [
          {
            Modulo: "faturamento",
            Acao: "deletecapalote",
            Payload: {
              lote_id: selectedItem.id,
              grupo_economico: this.$store.state.permissions.grupoEconomico,
              dt_alteracao: this.dt_alteracao
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return;
        }
        this.items.capa_lote_dt_alteracao = response.dt_alteracao
        let paramModal = {
          type: "success",
          title: "Sucesso",
          message: response.mensagem,
          callback:  ()=> {this.getLotes(); this.showUpload=true},
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: "Não", show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
    userInfo() {
      let paramModal = {
        type: "error",
        title: "Atenção!",
        message: this.parameter? "Não é possível excluir capa de lote de cronograma com envio automático." : "Você não possui permissão para executar esta ação. <br/> Contacte o seu gestor.",
        callback: null,
        btConfirm: { name: "Fechar", show: true },
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    } 
  },
  props: {
    items: Object,
    showUpload: Boolean,
    parameter: Boolean,
    status: String,
    getLotes: Function,
    userData: Object
  },
};
</script>

<style>
</style>